export const formatFacturaRecurrenteLibrado = (
  cliente: $TSMigrationFixMe,
  libradorId: $TSMigrationFixMe
) => {
  const editedCliente = {
    ...cliente,
    calle: cliente?.calle,
    cp: cliente?.codigoPostal,
    esFiscal: cliente?.esFiscal,
    id: cliente?.id,
    poblacionExtranjera: cliente?.poblacionExtranjera,
    poblacionId: cliente?.poblacionId,
    poblacion: cliente?.poblacionNombre,
    provinciaId: cliente?.provinciaId,
    libradorId,
  }
  return editedCliente
}
